import React from 'react';
import './RegulamentoPage.css';

export default function RegulamentoPage() {
  return (
    <div className="regulamento-page">
      <div className="regulamento-container">
        <h1 className="regulamento-title">Regulamento</h1>
        
        <p className="regulamento-intro">
          É importante conhecer o Regulamento do Barco de Papel - Academia de Criatividade
        </p>

        <div className="regulamento-content">
          <section className="regulamento-section">
            <h2>Objetivos</h2>
            <p>
              A Academia de Criatividade Barco de Papel tem como objetivo proporcionar momentos 
              de criatividade com experiências artísticas e lúdicas a crianças com idades 
              compreendidas entre os 5 e os 12 anos.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Serviços Disponíveis</h2>
            <div className="service-box">
              <h3>OFICINAS ARTÍSTICAS</h3>
              <p>
                Espaço dedicado às expressões com materiais artísticos + workshops com temas variados.
              </p>
            </div>

            <div className="service-box">
              <h3>BRINCOTECA</h3>
              <p>
                Espaço lúdico e de exploração sensorial com jogos, livros, zona de projeção 
                de vídeos e brinquedos.
              </p>
            </div>

            <p className="service-note">
              Serviços disponíveis diariamente para um mínimo de 7 crianças por turno entre 
              os 5 e os 12 anos.
            </p>

            <div className="service-box">
              <h3>FESTAS DE ANIVERSÁRIO</h3>
              <p>Até 15 crianças</p>
            </div>

            <div className="service-box">
              <h3>OFICINAS DE FÉRIAS</h3>
              <p>Até 15 crianças</p>
            </div>
          </section>

          <section className="regulamento-section">
            <h2>Inscrições e Preços</h2>
            <p>
              A inscrição é feita mediante o preenchimento de uma ficha de inscrição em 
              formato PDF editável ou no formulário do Site com o envio dos seguintes documentos:
            </p>
            <ul>
              <li>Cartão de cidadão da criança</li>
              <li>Cartão de cidadão do Enc. de Educação</li>
            </ul>
            <p>
              O mínimo de participação são 3 vezes por semana e a informação dos dias de 
              frequência, tem de ser comunicada por email ou por WhatsApp a partir do momento 
              em que o planeamento é enviado e até às 15h da quinta-feira anterior à frequência, 
              juntamente com o comprovativo de pagamento.
            </p>

            <h3>OFICINAS DE FÉRIAS:</h3>
            <p>
              A inscrição é feita mediante o preenchimento de uma ficha de inscrição em formato 
              PDF editável, o pagamento de 50% do valor total a pagar e o envio de cópias dos 
              seguintes documentos:
            </p>
            <ul>
              <li>Cartão de cidadão da criança</li>
              <li>Cartão de cidadão do Enc. de Educação</li>
            </ul>
            <p>
              Na ficha de inscrição deverá estar um número de telemóvel e um contacto adicional 
              que estejam sempre disponíveis para contactar em caso de emergência/necessidade, 
              também os nomes completos das pessoas autorizadas a recolher a criança nas 
              instalações da Academia Barco de Papel com respetivo número do documento de identificação.
            </p>

            <h3>PREÇOS:</h3>
            <p>
              Disponíveis no site <a href="https://www.barcodepapel.pt" target="_blank" rel="noopener noreferrer">www.barcodepapel.pt</a> e 
              nas publicações feitas nas redes sociais e sempre que solicitado. O pagamento 
              deve ser feito no ato da inscrição.
            </p>
          </section>

          <section className="regulamento-section highlight-section">
            <h2>Desistências / Faltas</h2>
            <p className="warning-text">
              Não será devolvido qualquer valor nem serão possíveis trocas por quaisquer 
              outros dias, em caso de falta da criança independentemente do motivo.
            </p>
            <ul>
              <li>
                Poderão ser feitas trocas de dias dentro da mesma semana se à frequência da 
                criança na Academia Barco de Papel e se existirem vagas.
              </li>
              <li>
                A semana é considerada de segunda a sexta-feira não sendo possível transitar 
                dias para a semana seguinte.
              </li>
              <li>
                As faltas de frequência não têm qualquer reembolso dos valores já pagos. O 
                valor pago com a inscrição (50%) não será devolvido em caso de desistência. 
                Haverá apenas a possibilidade de trocar a semana em que a criança está inscrita 
                por outra, caso ainda haja vagas para a semana pretendida e desde que esta 
                alteração seja comunicada até às 17h da quarta-feira da semana útil anterior 
                à semana em que inicialmente a criança estava inscrita.
              </li>
            </ul>
          </section>

          <section className="regulamento-section">
            <h2>Devolução de Valores Pagos</h2>
            <p>
              Qualquer valor pago só será devolvido se por algum motivo de força maior, a 
              Academia Barco de Papel tiver de encerrar portas.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Pagamento</h2>
            <p>
              O pagamento pode ser feito em:
            </p>
            <ul>
              <li><strong>Numerário</strong></li>
              <li><strong>MbWay:</strong> 936678220</li>
              <li><strong>Transferência bancária:</strong> IBAN: PT50 0045 1460 4031789219420</li>
            </ul>
            <p className="note-text">
              Na opção de transferência bancária é obrigatório o envio do comprovativo para 
              o email academiabarcodepapel@gmail.com
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Seguro</h2>
            <p>
              Todos os participantes estarão abrangidos por um seguro de Acidentes Pessoais 
              da Caixa Agrícola Seguros com a apólice n°02585744.
            </p>
            <p>
              O nome completo, n° de contribuinte e data de nascimento de cada criança é 
              enviado para a seguradora na sexta-feira anterior à semana em que está inscrita 
              para que o seguro seja acionado à primeira hora de cada segunda-feira.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Funcionamento</h2>
            <p>
              As crianças devem ser entregues e recolhidas à porta da Academia Barco de Papel, 
              no exterior, não sendo permitida a entrada, a qualquer pessoa, além das crianças 
              e elementos da equipa.
            </p>
            
            <h3>Autorizações para recolha da criança</h3>
            <p>
              As crianças só poderão sair acompanhadas pelo/a Encarregado de Educação ou 
              aquelas pessoas que na ficha de inscrição foram identificadas para esse fim. 
              A pessoa que recolher a criança tem de se fazer acompanhar pelo cartão de 
              cidadão físico. Só este documento é aceite como forma de identificação.
            </p>

            <h3>Registo Fotográfico</h3>
            <p>
              Durante as atividades desenvolvidas na Academia Barco de Papel irão ser recolhidas 
              imagens que serão partilhadas via WhatsApp através de um grupo criado para o efeito. 
              Nestas fotos não está preservada a identidade das crianças. Nas fotografias 
              divulgadas nas redes sociais e site a identidade da criança será sempre preservada.
            </p>
            <p>
              Para que a partilha de fotografias seja possível é necessário o preenchimento da 
              Autorização para registo fotográfico que é enviada inicialmente com a ficha de 
              inscrição. Para que a partilha de fotografias seja possível é necessário assinalar 
              na ficha de inscrição essa vontade no campo existente para o efeito.
            </p>

            <h3>Calçado e Cacifos</h3>
            <p>
              A criança deverá ter um calçado de uso exclusivo na Academia Barco de Papel 
              admitindo-se o uso de meias antiderrapantes.
            </p>
            <p>
              Cada criança terá um cacifo/caixa devidamente identificado que está localizado 
              na entrada do Barco de Papel.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Participantes</h2>
            <p>
              O Barco de Papel reserva-se o direito de após prévia informação e contacto com 
              o Encarregado de Educação, cessar a participação de qualquer criança, caso o seu 
              comportamento prejudique de forma significativa o normal funcionamento da atividade.
            </p>
            <p>
              Todos os participantes devem cumprir as instruções que lhe sejam dadas pela 
              educadora/monitora assim como cumprir o descritivo no presente regulamento.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Atividades</h2>
            <p>
              Os participantes terão acesso a todas as atividades salvo por razões de ordem 
              pessoal, técnica ou indicação do Encarregado de Educação.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Objetos Pessoais</h2>
            <p>
              Não é permitido trazer para a Academia Barco de Papel brinquedos ou qualquer 
              objeto de valor, à exceção de crianças em adaptação, caso se justifique.
            </p>
            <p className="warning-text">
              Não nos responsabilizamos pela deterioração da roupa das crianças.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Horários</h2>
            <p>
              Todos os participantes deverão cumprir os horários estabelecidos, devendo informar 
              o Barco de Papel no caso de necessidade de incumprimento.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Local</h2>
            <h3>Interior:</h3>
            <p>
              A academia de Barco de Papel situar-se na rua 31 janeiro número 12 Póvoa do Varzim.
            </p>
            
            <h3>Exterior:</h3>
            <p>
              As saídas do espaço Academia Barco de Papel serão feitas no limite, até ao parque 
              em frente (50 metros) estarão sempre previstas no planeamento semanal das atividades. 
              Estas saídas só acontecerão se todos os Encarregados de educação tiverem assinado 
              na ficha de inscrição, a autorização para o efeito.
            </p>
            <p>
              As visitas, passeios ou outras saídas serão sempre divulgadas antes de cada 
              Oficina de férias.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Equipa Pedagógica</h2>
            <p>A equipa é composta por:</p>
            <p>Educadora de Infância e 1 ou 2 auxiliares consoante o número de crianças.</p>
          </section>

          <section className="regulamento-section">
            <h2>Saúde</h2>
            <p>
              As crianças não devem ser medicadas antes de irem para o Barco de Papel. Qualquer 
              exceção deverá ser comunicada ao membro da equipa que receber a criança.
            </p>
            <p>
              Os encarregados de educação têm o dever de informar sobre antecedentes patológicos 
              e alergias, assim como de qualquer restrição alimentar ou não que a criança possua.
            </p>
            <p>
              Os medicamentos que eventualmente a criança necessite tomar, acompanhados pela 
              respetiva prescrição médica, serão entregues ao responsável que recebe a criança 
              no espaço, devendo os mesmos estar devidamente identificados com o nome da criança, 
              com as indicações de administração.
            </p>
            <p>
              Em caso de manifestação de sintomas de doença, obrigatoriedade de levar a criança 
              ao médico e solicitar declaração para o regresso.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Alimentação</h2>
            <p>
              O Barco de Papel fornece almoço e o lanche da tarde. O reforço da manhã, para as 
              manhãs com saídas, deverá ser trazido de casa (fruta, bolachas, garrafa de água 
              identificada) numa pequena mochila, com identificação visível no exterior.
            </p>
          </section>

          <section className="regulamento-section">
            <h2>Omissões</h2>
            <p>
              Todos os casos não previstos, ficarão à consideração da Academia de Criatividade 
              Barco de Papel.
            </p>
          </section>

          <section className="regulamento-section final-section">
            <h2>Considerações Finais</h2>
            <p>
              Ao efetuar a inscrição, os Encarregados de Educação estarão a aceitar de imediato 
              este Regulamento Interno que estará sempre disponível para consulta no site{' '}
              <a href="https://www.barcodepapel.pt" target="_blank" rel="noopener noreferrer">
                www.barcodepapel.pt
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}